import React from 'react';
import Navigation from '../../client/components/dashboardNew/components/Navigation';
import ProfileSummary from "../components/dashboardNew/components/ProfileSummary";
import SideBarHighlight from "../components/dashboardNew/components/SideBarHighlight";
import VideoModal from "../components/dashboardNew/components/modals/VideoModal";
import {PrismicDocumentHelper} from "../helpers/prismicHelpers/PrismicHelpers";


class SideBar extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isModalOpen : false,
			typeOfHighlight: '',
			featuredVideo: '',
			featuredContent: '',
			featuredExternal: ''
		};
	}

	openModal = () => {
		this.setState({
			isModalOpen: true
		})
	};

	closeModal = () => {
		this.setState({
			isModalOpen: false
		})
	};

	componentWillMount() {
		this.getHighlightData()
	}

	async getHighlightData() {
		const data = await PrismicDocumentHelper('document.type', 'sidebar_highlight', false, 'at');
		if( !data.result.length ){ return };
		let typeOfHighlight = data.result[0].data.sidebar_dropdown
		data.result[0].data.body.map(slice => {
			if(slice.slice_type === 'featured_video') {
				this.setState({featuredVideo: slice.primary})
			} else if (slice.slice_type === 'featured_content') {
				this.setState({featuredContent: slice.primary})
			} else {
				this.setState({featuredExternal: slice.primary})
			}
		})
		this.setState({typeOfHighlight})
    }

	render() {

		const {featuredVideo, featuredContent, featuredExternal} = this.state,
		{ pathname } = this.props;
		return (
			<div className="side-bar-wrapper">

				<div className="main-sidebar">
					<ProfileSummary pathname={ pathname } />
					<Navigation navClass='desktop-nav' />
					{this.state.typeOfHighlight && <SideBarHighlight
						openModal={this.openModal}
						sideBarHighlight={this.state.typeOfHighlight}
						videoThumbnail={featuredVideo.video_thumbnail.url}
						videoTitle={featuredVideo.video_title}
						featurelinkThumbnail={featuredContent.featured_content_thumbnail.url}
						featurelinkText={featuredContent.featured_content_title}
						featurelinkUrl={featuredContent.featured_content_link}
						advertHighlightThumbnail={featuredExternal.external_link_thumbnail.url}
						advertHighlightText={featuredExternal.external_link_title}
						advertHighlightUrl={featuredExternal.external_link_url}
					/>}
				</div>
				{/*Modal for video sits outside of Sidebarhighlight*/}
				<VideoModal
					closeModal={this.closeModal}
					modalState={this.state.isModalOpen}
					videoUrl={featuredVideo.video_url}
				/>

			</div>
		);
	}
};


export default SideBar;


// WEBPACK FOOTER //
// src/client/layouts/SideBar.js